<ng-container *ngIf="modalService.isVisible$ | async">
    <div class="modal-backdrop" (click)="closeModal($event)">
        <div class="profile-card" (click)="$event.stopPropagation()">
            <div class="profile-left">
                <div class="profile-image-container">
                    <img [src]="imagePreview || userProfile.profileImage" alt="profile-image" class="profile-image"
                        (error)="onImgError($event)" />

                    <button class="edit-button image-edit" (click)="fileInput.click()" title="Change profile image"
                        type="button" *ngIf="isEditMode">
                        <i class="bi bi-pencil-square"></i>
                    </button>
                    <input type="file" #fileInput style="display: none;" accept="image/*"
                        (change)="onFileSelected($event)" />
                </div>

                <h2 class="profile-name">{{ userProfile.username }}</h2>
                <div class="status-badge active">
                    Active
                </div>
            </div>

            <div class="profile-right">
                <!-- View Mode -->
                <div class="profile-details" *ngIf="!isEditMode">
                    <div class="modal-header main-edit">
                        <button class="edit-button-modal " (click)="toggleEditMode()">
                            <i class="bi bi-pencil-square"></i>
                        </button>
                        <button class="close-btn" (click)="handleManualClose($event)">
                            <i class="bi bi-x"></i>
                        </button>
                    </div>

                    <div class="detail-row mt-2">
                        <div class="detail-column">
                            <div class="detail-label">Name <span class="danger-text">*</span></div>
                            <div class="detail-value">{{ userProfile.username }}</div>
                        </div>
                        <div class="detail-column">
                            <div class="detail-label">Date of Birth <span class="danger-text">*</span></div>
                            <div class="detail-value">{{ userProfile.dateOfBirth }}</div>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-column">
                            <div class="detail-label">Staff ID <span class="danger-text">*</span></div>
                            <div class="detail-value">{{ userProfile.staffId }}</div>
                        </div>
                        <div class="detail-column">
                            <div class="detail-label">Phone <span class="danger-text">*</span></div>
                            <div class="detail-value">{{ userProfile.mobile }}</div>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-column">
                            <div class="detail-label">Designation <span class="danger-text">*</span></div>
                            <div class="detail-value">{{ userProfile.designation }}</div>
                        </div>
                        <div class="detail-column">
                            <div class="detail-label">Alternate Phone <span class="danger-text">*</span></div>
                            <div class="detail-value">{{ userProfile.alternatePhone }}</div>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-column full-width">
                            <div class="detail-label">Address <span class="danger-text">*</span></div>
                            <div class="detail-value">{{ userProfile.address }}</div>
                        </div>
                    </div>
                </div>

                <!-- Edit Mode -->
                <form [formGroup]="profileForm" (ngSubmit)="saveProfile()" class="profile-details" *ngIf="isEditMode">
                    <div class="modal-header main-edit" (click)="handleManualClose($event)">
                        <button class="close-button-modal">
                            <i class="bi bi-x"></i>
                        </button>
                    </div>
                    <div class="detail-row mt-2">
                        <div class="detail-column">
                            <div class="detail-label">Name <span class="danger-text">*</span></div>
                            <input type="text" formControlName="username" class="edit-input" required />
                            <div class="error-blk">
                                <div class="error-message"
                                    *ngIf="profileForm.get('username')?.touched && profileForm.get('username')?.hasError('required')">
                                    Name is required
                                </div>
                            </div>
                        </div>
                        <div class="detail-column">
                            <div class="detail-label">Date of Birth <span class="danger-text">*</span></div>
                            <input type="text" formControlName="dateOfBirth" class="edit-input" required />
                            <div class="error-blk">
                                <div class="error-message"
                                    *ngIf="profileForm.get('dateOfBirth')?.touched && profileForm.get('dateOfBirth')?.hasError('required')">
                                    DOB is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-column">
                            <div class="detail-label">Staff ID <span class="danger-text">*</span></div>
                            <input type="text" formControlName="staffId" class="edit-input" required readonly />
                            <div class="error-blk">
                                <div class="error-message"
                                    *ngIf="profileForm.get('staffId')?.touched && profileForm.get('staffId')?.hasError('required')">
                                    Staff ID is required
                                </div>
                            </div>
                        </div>
                        <div class="detail-column">
                            <div class="detail-label">Phone <span class="danger-text">*</span></div>
                            <input type="text" formControlName="phone" class="edit-input" required />
                            <div class="error-blk">
                                <div class="error-message"
                                    *ngIf="profileForm.get('phone')?.touched && profileForm.get('phone')?.hasError('required')">
                                    Phone Number is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-column">
                            <div class="detail-label">Designation <span class="danger-text">*</span></div>
                            <input type="text" formControlName="designation" class="edit-input" required readonly />
                            <div class="error-blk">
                                <div class="error-message"
                                    *ngIf="profileForm.get('designation')?.touched && profileForm.get('designation')?.hasError('required')">
                                    Designation is required
                                </div>
                            </div>
                        </div>
                        <div class="detail-column">
                            <div class="detail-label">Alternate Phone <span class="danger-text">*</span></div>
                            <input type="text" formControlName="alternatePhone" class="edit-input" required />
                            <div class="error-blk">
                                <div class="error-message"
                                    *ngIf="profileForm.get('alternatePhone')?.touched && profileForm.get('alternatePhone')?.hasError('required')">
                                    Alternate Phone Number is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="detail-row">
                        <div class="detail-column full-width">
                            <div class="detail-label">Address <span class="danger-text">*</span></div>
                            <input type="text" formControlName="address" class="edit-input" required />
                            <div class="error-blk">
                                <div class="error-message"
                                    *ngIf="profileForm.get('address')?.touched && profileForm.get('address')?.hasError('required')">
                                    Address is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="buttonaction">
                        <button type="button" class="secondary-btn" (click)="cancelEdit()">Cancel</button>
                        <button type="submit" class="primary-button">Update</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-container>